function getImageDimensions(url) {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => {
      resolve({ width: img.width, height: img.height, ratio: `${img.width}:${img.height}` });
    };
    img.onerror = reject;
    img.src = url;
  });
}

export { getImageDimensions };
